export default __webpack_public_path__ + "static/media/icon_guide_notice_uns.81706e9a.svg";